(function () {
  function money(c) { var d = c / 100; return '$' + (d % 1 ? d.toFixed(2) : d.toFixed(0)); }
  function paint(el, sub, count) {
    var thr = +el.dataset.threshold, ends = +el.dataset.ends, reward = el.dataset.reward, code = el.dataset.code || 'SPOOKY';
    var promo = Date.now() / 1000 <= ends;
    el.classList.toggle('lb-arc--promo', promo);
    var fill = promo ? (sub >= thr ? 100 : Math.floor(sub * 50 / thr)) : (count > 0 ? 100 : 0);
    el.classList.toggle('is-unlocked', promo && sub >= thr);
    var f = el.querySelector('.lb-arc__fill'); if (f) f.style.strokeDasharray = fill + ' 100';
    var dots = el.querySelectorAll('.lb-arc__dot');
    if (dots[0]) dots[0].classList.toggle('is-hit', count > 0);
    if (dots[1]) dots[1].classList.toggle('is-hit', sub >= thr);
    if (dots[2]) dots[2].classList.toggle('is-hit', fill >= 100);
    var m = el.querySelector('.lb-arc__msg');
    if (m) m.textContent = promo
      ? (sub >= thr ? reward + ' unlocked: use code ' + code + ' at checkout' : money(thr - sub) + ' to unlock ' + reward + ' with code ' + code)
      : (count > 0 ? 'Ready for checkout' : 'Add an item to start');
  }
  function refresh() {
    fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('[data-lb-arc]').forEach(function (el) { paint(el, c.items_subtotal_price, c.item_count); });
        document.querySelectorAll('[data-lb-co2]').forEach(function (el) {
          var T = (el.dataset.tonerTypes || '').split('|'), I = (el.dataset.inkTypes || '').split('|'), VN = (el.dataset.vendors || '').split('|'), lb = 0;
          (c.items || []).forEach(function (it) {
            if (VN.indexOf(it.vendor) < 0) return;
            if (T.indexOf(it.product_type) > -1) lb += it.quantity * 9.337;
            else if (I.indexOf(it.product_type) > -1) lb += it.quantity * 0.406;
          });
          el.hidden = !(lb > 0);
          var n = el.querySelector('[data-lb-co2-n]');
          if (n) n.textContent = (Math.round(lb * 10) / 10).toLocaleString('en-US', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
        });
      }).catch(function () {});
  }
  function init() {
    document.querySelectorAll('[data-lb-arc]').forEach(function (el) { paint(el, +el.dataset.subtotal, +el.dataset.count); });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(refresh, 50); });
    }
    document.addEventListener('cart:updated', refresh);
    // The drawer is re-rendered from the server on add/remove; repaint anything newly inserted.
    new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) for (var j = 0; j < ms[i].addedNodes.length; j++) {
        var n = ms[i].addedNodes[j];
        if (n.nodeType === 1 && (n.matches('[data-lb-arc]') || n.querySelector('[data-lb-arc]'))) { refresh(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  // Countdown (SPOOKY ends in 9 days 16 hours 16 minutes). Removes itself once the end time passes.
  function tick() {
    var now = Date.now() / 1000;
    document.querySelectorAll('[data-lb-count]').forEach(function (el) {
      var rem = Math.floor(+el.dataset.ends - now);
      if (rem <= 0) { el.remove(); return; }
      var d = Math.floor(rem / 86400), h = Math.floor(rem % 86400 / 3600), m = Math.floor(rem % 3600 / 60);
      function u(n, w) { return n + ' ' + w + (n === 1 ? '' : 's'); }
      var txt = (d > 0 ? u(d, 'day') + ' ' : '') + (d > 0 || h > 0 ? u(h, 'hour') + ' ' : '') + u(m, 'minute');
      var v = el.querySelector('[data-lb-count-v]');
      if (v && v.textContent !== txt) v.textContent = txt;
    });
  }
  function initCount() { tick(); setInterval(tick, 15000); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); initCount(); }); else { init(); initCount(); }
})();
